import axios from 'axios';
import { apolloClientInternal } from '@getaccept/lib-shared/src/internal/apollo-client-internal';
import { UploadFileMutations } from '../graphql/upload-file.mutations';
import type { UploadFileUrl } from '../../../types/upload-file-url';
import type { UploadDTO } from '../../../types/upload-dto';
import type { UploadDoneDto } from '../../../types/upload-done-dto';

export class UploadFileService {
  static async getUploadFilesUrls(
    documentId: string,
    filenames: string[]
  ): Promise<UploadFileUrl[]> {
    const {
      data: { getUploadFilesUrls },
    } = await apolloClientInternal.mutate({
      mutation: UploadFileMutations.getUploadFilesUrlsMutation,
      variables: { documentId, filenames },
    });
    return getUploadFilesUrls;
  }

  static async uploadFiles(uploadFileUrls: UploadFileUrl[], files: File[]): Promise<void> {
    await Promise.all(
      uploadFileUrls.map(async ({ uploadUrl }: UploadFileUrl, index: number) =>
        axios.put(uploadUrl, files[index])
      )
    );
  }

  static async uploadFilesDone(
    documentId: string,
    index: number,
    uniqueFilenames: string[]
  ): Promise<boolean> {
    const {
      data: { uploadFilesDone },
    } = await apolloClientInternal.mutate({
      mutation: UploadFileMutations.uploadFilesDoneMutation,
      variables: { documentId, index, uniqueFilenames },
    });
    return uploadFilesDone;
  }

  static async uploadFile({ file, uploadLink, headers }: UploadDTO): Promise<void> {
    const body = new FormData();
    Object.keys(headers).forEach((key: string) => body.append(key, headers[key]));
    body.append('file', file);

    return new Promise((res, rej) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', uploadLink, true);
      xhr.send(body);
      xhr.onload = function () {
        if (this.status === 204) {
          res();
        } else {
          rej(this.responseText);
        }
      };
    });
  }

  static async uploadFilesDoneV2(args: UploadDoneDto[]): Promise<boolean> {
    const { data } = await apolloClientInternal.mutate({
      mutation: UploadFileMutations.uploadFilesDoneV2,
      variables: { args, jobType: 'Archive' },
    });
    return data;
  }
}
